import { render, staticRenderFns } from "./dataRetrievalDetail.vue?vue&type=template&id=5d032d0e&scoped=true"
import script from "./dataRetrievalDetail.vue?vue&type=script&lang=js"
export * from "./dataRetrievalDetail.vue?vue&type=script&lang=js"
import style0 from "./dataRetrievalDetail.vue?vue&type=style&index=0&id=5d032d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d032d0e",
  null
  
)

export default component.exports